/**
 * ImageNode 在 PromptCard 父节点下的纵向自动重排
 * 触发：新生成 / 折叠展开 / 删除单张
 */

import type { Node } from '@xyflow/react'
import type { ImageNodeData } from './ImageNode'

export const CHILD_X = 420
export const GAP = 16
export const COLLAPSED_H = 56
export const EXPANDED_H = 408

interface ReactFlowLike {
  setNodes: (updater: (nodes: Node[]) => Node[]) => void
}

/**
 * 重排某 PromptCard 下所有 ImageNode 子节点为无空白纵向堆叠。
 * 排序按 id 字典序（id 含 Date.now() 时间戳，等同生成顺序）。
 */
export function reflowChildren(rf: ReactFlowLike, parentId: string) {
  rf.setNodes((nodes) => {
    const children = nodes
      .filter((n) => n.parentId === parentId && n.type === 'image-node')
      .sort((a, b) => a.id.localeCompare(b.id))

    const newPositions = new Map<string, { x: number; y: number }>()
    let cumY = 0
    for (const c of children) {
      newPositions.set(c.id, { x: CHILD_X, y: cumY })
      const collapsed = (c.data as ImageNodeData)?.collapsed ?? false
      cumY += (collapsed ? COLLAPSED_H : EXPANDED_H) + GAP
    }

    return nodes.map((n) => {
      const p = newPositions.get(n.id)
      if (!p) return n
      if (n.position.x === p.x && n.position.y === p.y) return n
      return { ...n, position: p }
    })
  })
}
